import { render, staticRenderFns } from "./orderDialog.vue?vue&type=template&id=3271862c&scoped=true&"
import script from "./orderDialog.vue?vue&type=script&lang=js&"
export * from "./orderDialog.vue?vue&type=script&lang=js&"
import style0 from "./orderDialog.vue?vue&type=style&index=0&id=3271862c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3271862c",
  null
  
)

export default component.exports